// extracted by mini-css-extract-plugin
export var infoRow = "_on-2";
export var labelContainer = "_on-0";
export var rightInfo = "_on-1";